import React, { useState, useEffect, useCallback } from "react";
import Location from "../fields/Location";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers-pro";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { IoCarSportOutline } from "react-icons/io5";
import { GoPeople } from "react-icons/go";
import { IoLocationOutline } from "react-icons/io5";
import { IoCalendarOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import MultipleSelectChip from "../fields/MultiSelect";
import { useDispatch, useSelector } from "react-redux";
import {
  clearCarModalList,
  getCarModal,
  getCarType,
} from "../../redux/Slice/formSlice";
import {
  clearSearchQuery,
  fetchFilters,
  filterCars,
  getAllCars,
  setSearchQuery,
} from "../../redux/Slice/carSlice";
import { FaSearch } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { styled } from "@mui/material/styles";
import { Slider, Switch, Tooltip } from "@mui/material";
import { IoPersonAddOutline } from "react-icons/io5";
import {
  cleanBookingData,
  setBookingData,
  setPersonalDetailsData,
} from "../../redux/Slice/bookingSlice";
import { scroller } from "react-scroll";
import SelectInput from "../fields/SelectInput";
import MapWithModal from "../fields/MapWithLocation";
import { Box } from "@mui/system";
import CustomizedSlider from "../fields/RangeSlider";
import MultipleSelectWithAutocomplete from "../fields/MultipleSelectWithAutocomplete";
const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 40,
  height: 20,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 10,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(18px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 3,
    "&.Mui-checked": {
      transform: "translateX(18px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#008080 !important", // Track color when checked
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 14,
    height: 14,
    borderRadius: 15,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 15,
    opacity: 1,
    backgroundColor: "#424242 !important", // Track color when unchecked
    boxSizing: "border-box",
  },
}));
const CarSearchForm = ({ ishome, setCurrentPage }) => {
  const pathName = useLocation();
  const today = new Date();
  const date = new Date();
  const dispatch = useDispatch();
  date.setDate(date.getDate() + 1);
  const carTypeList = useSelector((state) => state?.form?.carTypeList);
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const { isFiltered, searchQuery, fetchFiltersResp } = useSelector(
    (state) => state?.car
  );
  const carMakeList = useSelector((state) => state?.form?.carMakeList);
  const carModalList = useSelector((state) => state?.form?.carModalList);
  const [mergedData, setMergedData] = useState([]);
  // console.log("isFiltered", isFiltered);
  const [carType, setCarType] = useState(
    isFiltered ? searchQuery?.filterQuery?.carType || [] : []
  );
  // const [carMake, setCarMake] = useState(''); // old code for only 1 value
  // const [carModel, setCarModel] = useState('');  // old code for only 1 value
  const [carMake, setCarMake] = useState(
    isFiltered ? searchQuery?.filterQuery?.carMaker || [] : []
  );
  const [carModel, setCarModel] = useState(
    isFiltered ? searchQuery?.filterQuery?.carModel || [] : []
  );
  const nextTwoDays = date.toISOString().split("T")[0];
  const navigate = useNavigate();
  // const [pickupDate, setPickupDate] = useState(dayjs(today)); // not required dv
  const [pickupDate, setPickupDate] = useState(null);
  const [location, setLocation] = useState("");
  const [radiusValue, setRadiusValue] = useState(0);
  // const [location, setLocation] = useState(carDetails?.carLocation || "");
  // const [returnDate, setReturnDate] = useState(dayjs(nextTwoDays));
  const [returnDate, setReturnDate] = useState(null);
  const [btnToggle, setBtnToggle] = useState(false);
  const [isChecked, setIsChecked] = useState(() => {
    const savedValue = sessionStorage.getItem("isChecked");
    return savedValue ? JSON.parse(savedValue) : false;
  });
  // console.log("driver", isChecked);
  const [errmsg, setErrMsg] = useState({
    carFeature: "",
    locationErrMsg: "",
    passenger: "",
  });
  // function renameCarMake(data) {
  //   return data?.map((item) => {
  //     const { carMake, ...rest } = item;
  //     return { name: carMake, ...rest };
  //   });
  // }

  // function renameCarModal(data) {
  //   return data?.map((item) => {
  //     const { carModel, ...rest } = item;
  //     return { name: carModel, ...rest };
  //   });
  // }

  // function renameCarType(data) {
  //   return data?.map((item) => {
  //     const { categoryName, ...rest } = item;
  //     return { name: categoryName, ...rest };
  //   });
  // }

  // function renameCarFeature(data) {
  //   return data?.map((item) => {
  //     const { carFeature, ...rest } = item;
  //     return { name: carFeature, ...rest };
  //   });
  // }

  const renameCarMake = useCallback(
    (data) => {
      return data?.map((item) => {
        const { carMake, ...rest } = item;
        return { name: carMake, ...rest };
      });
    },
    [carMake, carMakeList]
  );

  const renameCarModal = useCallback((data) => {
    return data?.map((item) => {
      const { carModel, ...rest } = item;
      return { name: carModel, ...rest };
    });
  }, []);

  const renameCarType = useCallback((data) => {
    return data?.map((item) => {
      const { categoryName, ...rest } = item;
      return { name: categoryName, ...rest };
    });
  }, []);

  const renameCarFeature = useCallback((data) => {
    return data?.map((item) => {
      const { carFeature, ...rest } = item;
      return { name: carFeature, ...rest };
    });
  }, []);
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  const [setSearchDetail] = useState({
    carType: [],
    passenger: "",
  });
  const [passenger, setPassenger] = useState([]);
  const [ln, setLn] = useState(null);
  const seatList = [
    {
      _id: "2",
      name: "2 Seater",
    },
    {
      _id: "3",
      name: "3 Seater",
    },
    {
      _id: "4",
      name: "4 Seater",
    },
    {
      _id: "5",
      name: "5 Seater",
    },
    {
      _id: "6",
      name: "6 Seater",
    },
    {
      _id: "7",
      name: "7 Seater",
    },
  ];

  const FuelType = [
    {
      _id: "Diesel",
      name: "Diesel",
    },
    {
      _id: "Petrol",
      name: "Petrol",
    },
    {
      _id: "Electric",
      name: "Electric",
    },
  ];

  // const [err, setErr] = useState({
  //     carTypeErr: false,
  //     locationErr: false,
  //     passengerErr: false
  // })

  // const [errmsg, setErrMsg] = useState({
  //     carFeature: "",
  //     passengerErrMsg: ""
  // })

  // useEffect(() => {
  //     async function getGeoLocation() {

  //         const result = await geocodeByAddress(location);
  //         const geoLocation = await getLatLng(result[0])
  //         setLn(geoLocation);
  //     }
  //     if (location) {

  //         getGeoLocation();
  //     }
  // }, [location])

  const handleInput = (event) => {
    const { name, value } = event.target;
    setPassenger((prevFormData) => [...prevFormData, value]);
  };

  const handleSubmit = async (e) => {
    setCurrentPage && setCurrentPage(1);
    let geoLocation;
    if (location && location.trim()) {
      const result = await geocodeByAddress(location);
      geoLocation = await getLatLng(result[0]);
    }

    e.preventDefault();

    let newErrMsg = {};
    // if (carType?.length === 0)
    //   newErrMsg = { ...newErrMsg, carFeature: "Enter Car Type" };
    // if (passenger?.length === 0)
    //   newErrMsg = { ...newErrMsg, passenger: "Enter Required Seats" };
    if (location.trim() === "" || !location)
      newErrMsg = { ...newErrMsg, locationErrMsg: "Enter Pick-up Location" };

    setErrMsg(newErrMsg);

    // if (carType?.length === 0 || passenger?.length === 0 || location === "") {
    if (location.trim() === "" || !location) {
      return;
    } else {
      // navigate('/carlist')
      // const isToday = dayjs(pickupDate).isSame(today, "day");

      // if (isToday) {
      //   // Update pickupDate with current time if it is today's date
      //   setPickupDate(dayjs());
      // }
      dispatch(
        filterCars({
          filterQuery: {
            carType: carType,
            // old code when maker and model fields not available
            // carmaker: [],
            // carmodel: [],
            // carmaker: carModel,
            // carmodel: carMake,
            carmaker: carMake,
            carmodel: carModel,
            numberOfSeats: passenger,
          },
          userId: userDetail?.data?._id,
          userLat: geoLocation?.lat,
          userLong: geoLocation?.lng,
          pickUpDateandTime: pickupDate,
          returnDateandTime: returnDate,
          withDriver: isChecked,
          price: 1,
          radius:radiusValue
        })
      );
      dispatch(
        setSearchQuery({
          filterQuery: {
            carType: carType,
            // old code when maker and model fields not available
            // carmaker: [],
            // carmodel: [],
            carMaker: carMake,
            carModel: carModel,
            numberOfSeats: passenger,
          },
          // userId: userDetail?.data?._id,
          userLat: geoLocation?.lat,
          userLong: geoLocation?.lng,
          pickUpDateandTime: pickupDate,
          returnDateandTime: returnDate,
          withDriver: isChecked,
          price: 1,
          btnToggle: true,
          location: location,
          radius:radiusValue
        })
      );
      dispatch(
        setBookingData({
          pickUp: pickupDate,
          dropOff: returnDate,
        })
      );
      dispatch(
        setPersonalDetailsData({
          name: "",
          emailId: "",
          phone: "",
          address: location,
        })
      );

      setBtnToggle(!btnToggle);
      setTimeout(() => {
        scroller.scrollTo("searchResult", {
          duration: 800,
          delay: 0,
          smooth: "easeInOutQuart",
          offset: -150, // Adjust offset here
        });
      }, 500);
    }
  };
  function valuetext(value) {
    return `${value}`;
  }
  const clearSearch = () => {
    setReturnDate(null);
    setPickupDate(null);
    setCarType([]); // Clear car type
    setCarMake([]); // Clear car type
    setCarModel([]); // Clear car type
    setPassenger([]); // Clear passenger
    setLocation(""); // Clear location
    // setPickupDate(dayjs(today)); // Reset pickup date to today
    // setReturnDate(dayjs(nextTwoDays)); // Reset return date to two days ahead
    setErrMsg({
      carFeature: "",
      locationErrMsg: "",
      passenger: "",
    });
    // Call filterCars with empty parameters to reset the search results
    // dispatch(
    //   filterCars({
    //     filterQuery: {},
    //     userId: userDetail?.data?._id,
    //     userLat: null,
    //     userLong: null,
    //     pickUpDateandTime: null,
    //     returnDateandTime: null,
    //     withDriver: isChecked,
    //     price: 1,
    //   })
    // );
    dispatch(cleanBookingData());
    dispatch(getAllCars());
    dispatch(clearSearchQuery());
    // settimeout for glitchy scrolling issue
    setTimeout(() => {
      scroller.scrollTo("searchResult", {
        duration: 800,
        delay: 0,
        smooth: "easeInOutQuart",
        offset: -150, // Adjust offset here
      });
    }, 500);
    setBtnToggle(false); // Set button toggle to false (Search mode)
  };
  // console.log("fetch",fetchFiltersResp?.data?.carModel)

  useEffect(() => {
    dispatch(getCarType());
    dispatch(fetchFilters());
    if (isFiltered) {
      // updating values for search fields by Redux value
      setLocation(searchQuery?.location);
      setBtnToggle(searchQuery?.btnToggle);
      setCarType(searchQuery?.filterQuery?.carType);
      setPassenger(searchQuery?.filterQuery.numberOfSeats);
      setPickupDate(
        searchQuery?.pickUpDateandTime
          ? dayjs(searchQuery?.pickUpDateandTime)
          : null
      ); // Reset pickup date to today
      setReturnDate(
        searchQuery?.returnDateandTime
          ? dayjs(searchQuery?.returnDateandTime)
          : null
      ); // Reset return date to two days ahead
      setPassenger(searchQuery?.filterQuery?.numberOfSeats);
      setCarMake(searchQuery?.filterQuery?.carMaker || []);
      setCarModel(searchQuery?.filterQuery?.carModel || []);
    }
    if (!isFiltered) {
      dispatch(cleanBookingData());
    }
  }, []);

  useEffect(() => {
    setBtnToggle(false);
  }, [carType, passenger, location, pickupDate, returnDate, isChecked]);

  const handlePickupDateChange = (newValue) => {
    setPickupDate(newValue);
    const nextDay = dayjs(newValue).add(1, "day");
    // setReturnDate(nextDay);
  };
  function availableSeat(carType, seatList) {
    if (carType.length) {
      // let data = carTypeList?.find((item) => item._id === carType);
      const matchedCars = carTypeList.filter((car) =>
        carType.includes(car._id)
      );
      const carWithLowestSeats =
        matchedCars.length &&
        matchedCars?.reduce((lowest, car) => {
          return lowest.numberOfSeats < car.numberOfSeats ? lowest : car;
        });
      return seatList?.filter(
        (item) => +item?._id >= carWithLowestSeats?.numberOfSeats
      );
    } else {
      return [];
    }
  }
  useEffect(() => {
    // if (isFiltered) setPassenger(searchQuery?.filterQuery?.numberOfSeats);
    // else setPassenger([]);
    if (searchQuery?.filterQuery?.carType?.length !== carType.length) {
      setPassenger([]);
    }
  }, [carType]);
  useEffect(() => {
    setErrMsg((prev) => ({ ...prev, locationErrMsg: "" }));
  }, [location]);

  // useEffect(() => {
  //   if (isFiltered) setPassenger([]);
  // }, [carType]);
  // useEffect(() => {
  //   if (isFiltered) setPassenger(searchQuery?.filterQuery?.numberOfSeats);
  // }, []);

  // Update session storage whenever isChecked changes
  useEffect(() => {
    sessionStorage.setItem("isChecked", JSON.stringify(isChecked));
  }, [isChecked]);

  const handleCarType = (event) => {
    const { name, value, type } = event.target;
    // console.log(name, 47);
    setErrMsg((prev) => ({ ...prev, carFeature: "" }));
    // console.log(value, 300)
    setCarType([value]);
    if (setPassenger) {
      // code added to clear seat var in search
      setPassenger([]);
    }
  };
  const findAndUpdateCategory = (id, categories) => {
    const category = categories.find((cat) => cat._id === id);
    if (category) {
      category.categoryName = category.categoryName.replace(/\s+/g, "");
    }
    return category;
  };
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   if (name === "carMake") {
  //     dispatch(getCarModal(value));
  //     setCarMake(value);
  //   } else if (name === "carModel") {
  //     console.log("modal",carModalList,fetchFiltersResp)
  //     // console.log(value,998)
  //     // console.log(carModalList,999)
  //     let type=carModalList && carModalList?.find(car => car._id.trim() === value.trim());
  //     const carCategoryId = type?.carCategory?.trim(); // Trim any spaces from the dynamic _id

  //     // Find the car object in the list with the matching _id
  //     const carCategory = carTypeList?.find(car => car._id === carCategoryId);
  //     console.log(carCategory,1452)
  //     setCarType([carCategory?._id]);
  //     // let data=carModalList?.filter((car)=>{
  //     //   console.log(car.carMakeId,value ,1450)
  //     //   return car.carMakeId === value
  //     // })
  //     setCarModel(value);
  //   }
  // };
  useEffect(() => {
    if (carMake?.length) {
      const fetchData = async () => {
        try {
          const results = await Promise.all(
            carMake.map((id) => dispatch(getCarModal(id)).unwrap())
          );
          // console.log('All API data:', results);
          const mergedData = results.flatMap((response) => response.data);
          setMergedData(mergedData);
          // Now you have all the API data in the 'results' variable
          // You can store it in state or use it as needed
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    } else {
      setCarModel([]);
      setMergedData([]);
    }
  }, [carMake]);
  useEffect(() => {
    // console.log(carModel,474)
    if (carModel?.length) {
      let carTypesArray = [];
      // console.log(mergedData,478);

      carModel?.length &&
        carModel?.forEach((value) => {
          let type =
            mergedData &&
            mergedData?.find((car) => car._id.trim() === value.trim());
          // console.log(type?.carCategory,2000)
          const carCategoryId = type?.carCategory?.trim(); // Trim any spaces from the dynamic _id
          const carCategory = carTypeList?.find(
            (car) => car._id === carCategoryId
          );
          // console.log(carCategory,1452)
          if (carCategory && !carTypesArray.includes(carCategory._id)) {
            carTypesArray.push(carCategory._id);
          }
          // setCarType([carCategory?._id]);
        });
      // console.log(carTypesArray,489)
      setCarType(carTypesArray);
    } else {
      setCarType([]);
    }
  }, [carModel]);
  return (
    <div className="car-nav-form mt-3 mt-md-4 mx-md-auto max_container ">
      <div className=" row px-2 row-gap-2 ">
        {/* <div className="col-md-3" name="carMake"> */}
        {/* col-lg-2 replaced below col-lg-3 */}
        <div className="col-6 col-lg-3 px-1 mb-3 mb-lg-0 mb-3 mb-lg-0 col-md-4">
          <p className="accentColor mb-lg-2 mb-2 text-start fw-medium">
            {" "}
            <IoCarSportOutline className="fs18 me-1" />
            Car maker
            {/* <span className="text-danger">*</span> */}
          </p>
          {/* <SelectInput
            noLabel={true}
            labelName="Car Maker:"
            placeholder="Enter Car Maker"
            value={carMake}
            onChange={handleInputChange}
            options={renameCarMake(carMakeList)}
            name="carMake"
            id="carmake"
            // error={!!errmsg?.carMake}
            // helperText={errmsg?.carMake}
          /> */}
          <MultipleSelectWithAutocomplete
            // labelName="Features:"
            placeholder="Enter Car Maker"
            value={carMake}
            setFeature={setCarMake}
            // setPassenger={setPassenger}
            feature={carMake}
            options={renameCarMake(carMakeList)}
            setErrMsg={setErrMsg}
            // options={carFeaturesList}
            name="carMake"
            id="carMake"
            // error={!!errmsg?.carFeature}
            // helperText={errmsg?.carFeature}
            // requiredStar={true}
          />
        </div>
        {/* <div className="col-md-3"> */}
        <div className="col-6 col-lg-3 px-1 mb-3 mb-lg-0 mb-3 mb-lg-0 col-md-4">
          <p className="accentColor mb-lg-2 mb-2 text-start fw-medium">
            {" "}
            <IoCarSportOutline className="fs18 me-1" />
            Car Model
            {/* <span className="text-danger">*</span> */}
          </p>
          {/* <SelectInput
           noLabel={true}
            labelName="Car Model:"
            placeholder="Enter Car Model"
            value={carModel}
            onChange={handleInputChange}
            // options={renameCarModal(carModalList)} // single type modal list 
            options={renameCarModal(mergedData)}  // all selected type modal list 
            name="carModel"
            id="carmodel"
            error={!!errmsg?.carModel}
            helperText={errmsg?.carModel}
          /> */}
          {/* <MultipleSelectChip */}
          <MultipleSelectWithAutocomplete
            // labelName="Features:"
            placeholder="Enter Car Model"
            value={carModel}
            setFeature={setCarModel}
            // setPassenger={setPassenger}
            feature={carModel}
            options={renameCarModal(mergedData)} // all selected type modal
            // setErrMsg={setErrMsg}
            // options={carFeaturesList}
            name="carModel"
            id="carmodel"
            // error={!!errmsg?.carFeature}
            // helperText={errmsg?.carFeature}
            requiredStar={true}
          />
        </div>
        <div className="col-6 col-lg-3 px-1 mb-3 mb-lg-0 mb-3 mb-lg-0 col-md-4">
          <p className="accentColor mb-lg-2 mb-2 text-start fw-medium">
            {" "}
            <IoCarSportOutline className="fs18 me-1" />
            Car Type
            {/* <span className="text-danger">*</span> */}
          </p>
          {/* <TextInput
                        id="carType"
                        type="text"
                        formPlaceholder="Enter Car Type"
                        shrink="false"
                        animation="true"
                        name="carType"
                        onChange={handleInput}
                        error={!!errmsg?.carFeature}
                        helperText={errmsg?.carFeature}
                        size="small"
                    /> */}
          <MultipleSelectChip
            // labelName="Features:"
            placeholder="Enter Car Type"
            value={carType}
            setFeature={setCarType}
            setPassenger={setPassenger}
            feature={carType}
            options={renameCarType(carTypeList)}
            setErrMsg={setErrMsg}
            // options={carFeaturesList}
            name="carFeature"
            id="carFeature"
            error={!!errmsg?.carFeature}
            helperText={errmsg?.carFeature}
            requiredStar={true}
            isBlock={true}
          />

          {/* <SelectInput
            isDisable={false}
            labelName="Car Type:"
            placeholder="Enter Car Type"
            value={carType}
            // onChange={handleCarType}
            options={renameCarType(carTypeList)}
            name="carFeature"
            id="carFeature"
            error={!!errmsg?.carFeature}
            helperText={errmsg?.carFeature}
            noLabel={true}
          /> */}
        </div>
        <div className="col-6 col-lg-3 px-1 mb-3 mb-lg-0 col-md-4">
          <p className="accentColor mb-lg-2 mb-2 text-start fw-medium">
            {" "}
            <GoPeople className="fs18 me-1" />
            Seats
            {/* <span className="text-danger">*</span> */}
          </p>
          {/* <TextInput
                        id="passenger"
                        type="number"
                        formPlaceholder="Number of Seats"
                        name="passenger"
                        shrink="false"
                        animation="true"
                        onChange={handleInput}
                        error={!!errmsg?.passenger}
                        helperText={errmsg?.passenger}
                        size="small"
                    /> */}
          {/* <SelectInput
                        // labelName="Number of Seats:"
                        placeholder="Number of Seats"
                        // value={CarDetail?.seat}
                        onChange={handleInput}
                        options={seatList}
                        name="passenger"
                        id="seatingcapacity"
                        error={!!errmsg?.passenger}
                        helperText={errmsg?.passenger}
                    /> */}
          <MultipleSelectChip
            placeholder="Number of Seats"
            value={passenger}
            setFeature={setPassenger}
            feature={passenger}
            setErrMsg={setErrMsg}
            // options={seatList}
            options={availableSeat(carType, seatList)}
            // options={carFeaturesList}
            name="passenger"
            id="seatingcapacity"
            error={!!errmsg?.passenger}
            helperText={errmsg?.passenger}
            requiredStar={true}
          />
        </div>
        {/* col-md-12 old replaced by col-md-6 */}
        <div className="col-6 col-lg-3 px-1 mb-3 mb-lg-0 col-md-4">
          <p className="accentColor mb-lg-2 mb-2 text-start fw-medium">
            <IoLocationOutline className="fs18 me-1" />
            Pick-up Location
            <span className="text-danger">*</span>
          </p>
          {/* <Location
                        placeholder="Enter Pick-up location"
                        error={!!errmsg?.locationErrMsg}
                        helperText={errmsg?.locationErrMsg}
                        setLocation={setLocation}
                        location={location}

                    /> */}
          {/* <Location
            type="filterSrch"
            placeholder="Enter Pick-up location"
            error={!!errmsg?.locationErrMsg}
            helperText={errmsg?.locationErrMsg}
            setLocation={setLocation}
            location={location}
          /> */}
          <MapWithModal
            type="filterSrch"
            placeholder="Enter Pick-up location"
            error={!!errmsg?.locationErrMsg}
            helperText={errmsg?.locationErrMsg}
            setLocation={setLocation}
            location={location}
          />
        </div>

        {/* col-6 col-lg-3 px-1 mb-3 mb-lg-0 */}
        <div className="col-6 col-lg-2 col-md-4  px-1">
          <p className="accentColor mb-lg-2 mb-2 text-start fw-medium">
            {" "}
            <IoCalendarOutline className="fs18 me-1" /> Pick-up Date{" "}
          </p>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              disablePast
              value={pickupDate}
              onChange={handlePickupDateChange}
              // onChange={(newValue) => setPickupDate(newValue)}
              sx={{ width: "100%" }}
              slotProps={{ textField: { size: "small", readOnly: true } }}
            />
          </LocalizationProvider>
        </div>
        <div className="col-6 col-lg-2 col-md-4  px-1">
          <p className="accentColor mb-lg-2 mb-2 text-start fw-medium">
            {" "}
            <IoCalendarOutline className="fs18 me-1" /> Return Date{" "}
          </p>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              // disablePast
              minDate={pickupDate}
              value={returnDate}
              onChange={(newValue) => setReturnDate(newValue)}
              sx={{ width: "100%" }}
              slotProps={{ textField: { size: "small", readOnly: true } }}
            />
          </LocalizationProvider>
        </div>
        <div className=" col-6 col-lg-2 col-md-4  px-1">
          <CustomizedSlider
            label={"Radius (KM)"}
            min={0}
            max={300}
            setValue={setRadiusValue}
            value={radiusValue}
         
          />
        </div>
        {/* col-md-6 col-lg-3 px-1 */}
        <div className="col-lg-3 col-md-4 px-1">
          <div className="d-flex justify-content-between w-100">
            <p className="accentColor mb-1 fw-medium">
              {" "}
              <IoPersonAddOutline className="fs18 me-1" /> Driver
            </p>
            <div className="">
              <AntSwitch
                onChange={handleCheckboxChange}
                checked={isChecked}
                inputProps={{ "aria-label": "ant design" }}
              />
            </div>
          </div>

          <div className="mt-1 d-flex justify-content-center align-items-center">
            <div
              className={`align-items-center d-flex gap-1 w-100 ${
                Object.values(errmsg)?.filter((ele) => ele !== "")?.length
                  ? // ? "mt-2"
                    ""
                  : ""
              }`}
            >
              <Tooltip title="Search">
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="btn img-btn py-lg-2 w-50 primaryColor mh40 d-flex align-items-center gap-1 justify-content-center"
                >
                  <FaSearch />
                </button>
              </Tooltip>
              <Tooltip title="Clear">
                <button
                  type="button"
                  onClick={clearSearch}
                  className="btn img-btn py-lg-2 w-50  primaryColor mh40 d-flex align-items-center gap-1 justify-content-center"
                >
                  <IoClose className="fs-6" />
                </button>
              </Tooltip>
            </div>
          </div>

          {/* <div className="d-flex align-items-center justify-content-between mb-2">
            <p className="accentColor mb-0 fw-medium">
              {" "}
              <IoPersonAddOutline className="fs18 me-1" /> Driver
            </p>
            <div className="d-flex justify-content-center align-items-center">
              <AntSwitch
                onChange={handleCheckboxChange}
                checked={isChecked}
                inputProps={{ "aria-label": "ant design" }}
              />
            </div>
          </div>
          <div className="align-items-center  flex-lg-column  d-flex gap-3 mt-md-2 mt-lg-0 mb-lg-0 "> */}

          {/* {btnToggle ? (
            <button
              type="button"
              onClick={clearSearch}
              className="btn img-btn py-lg-2 w-100 primaryColor f12 pad-btn"
            >
              <IoClose className="fs-6" /> Clear{" "}
            </button>
          ) : (
            <button
              type="submit"
              onClick={handleSubmit}
              className="btn img-btn py-lg-2 w-100 primaryColor mh40 d-flex align-items-center gap-1 justify-content-center"
            >
              <FaSearch />
            </button>
          )} */}

          {/* <div
              className={`align-items-center d-flex gap-1 w-100 ${
                Object.values(errmsg)?.filter((ele) => ele !== "")?.length
                  ? // ? "mt-2"
                    ""
                  : ""
              }`}
            >
              <Tooltip title="Search">
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="btn img-btn py-lg-2 w-50 primaryColor mh40 d-flex align-items-center gap-1 justify-content-center"
                >
                  <FaSearch />
                </button>
              </Tooltip>
              <Tooltip title="Clear">
                <button
                  type="button"
                  onClick={clearSearch}
                  className="btn img-btn py-lg-2 w-50  primaryColor mh40 d-flex align-items-center gap-1 justify-content-center"
                >
                  <IoClose className="fs-6" />
                </button>
              </Tooltip>
            </div> */}

          {/* {errmsg?.carFeature ||
          errmsg?.passenger ||
          errmsg?.locationErrMsg ? (
            <p className="location-err invisible search-inv">Search</p>
          ) : null} */}

          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default CarSearchForm;
